import React from 'react';
import { Button } from '@material-ui/core';

// Import assets
import { LogOutIcon } from 'assets/images/icons/LogOutIcon';

// Import styles
import { useStyles } from '../styles';

// Import utilities
import { useSignOutButton } from './useSignOutButton';

// Import components
import { LoadingOverlay } from 'components/elements';

export const SignOutButton = () => {
	const classes = useStyles();

	const { onClick, isAuthenticated, isLoading } = useSignOutButton();

	if (!isAuthenticated) return null;

	return (
		<>
			{isLoading && <LoadingOverlay />}

			<Button
				className={classes.headerBtn}
				onClick={onClick}
				variant="contained"
				color="primary"
			>
				<LogOutIcon />
			</Button>
		</>
	);
};
